const CustomValidation = {
    init() {
        $.validator.addMethod('customTel', function(value) {
            var pattern = /^(?=.*[0-9])[- +()0-9]+$/;

            return pattern.test(value);
        }, 'Please enter a valid telephone number');
        $.validator.addMethod('passwordCheck', function(value) {
            return /^[a-zA-Z0-9!@#$%^&*()_=[\]{};':"\\|,.<>/?+-]+$/.test(value) &&
                /[a-z]/.test(value) // has a lowercase letter
                &&
                /\d/.test(value) //has a digit
                &&
                /[!@#$%^&*()_=[\]{};':"\\|,.<>/?+-]/.test(value)
            // var pattern = (/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z](?=@#$%^&*()_=\[\]{};':"\\|,.<>\/?+-]+)).{8,}$/);

            // return pattern.test(value);
        }, 'Please enter a valid password with 1 digit, 1 lower case, 1 upper case letter and should be of 8 characters');

        $.validator.addMethod('noDecimal', function(value) {
            return !(value % 1);
        }, 'Days in part not allowed :)');

        $.validator.addMethod('customemail', function(value) {
            var pattern = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;

            return pattern.test(value);
        }, 'Please enter a valid email address');

        $.validator.addMethod('SGNumber', function(value) {
            var pattern = /^[6|8|9]\d{7}|(\+65[6|8|9]\d{7})|\+65\s[6|8|9]\d{7}/;
            return pattern.test(value);
        }, 'Please enter a valid Singapore Number only');

        $.validator.addMethod('noSpace', function(value) {
            return value.indexOf(' ') < 0 && value != '';
        }, 'Space are not allowed');

        // Banning specific addresses
        let bannedEmails = ['gmail', 'yahoo', 'hotmail', 'aol.com', 'outlook', 'yopmail', 'rediff', 'zoho.com', 'protonmail', 'gmx.com', 'yandex'];
        $.validator.addMethod('emailNotBanned', function(value) {
            let splitEmail = value.split('@');
            if (splitEmail.length > 1) {
                splitEmail = splitEmail[1];
            } else {
                return true;
            }

            for (let i = 0; i < bannedEmails.length; i++) {
                if (splitEmail.indexOf(bannedEmails[i]) !== -1) {
                    return false;
                }
            }
            return true;
        }, 'Please use your work email to continue or drop your email <a href="mailto:info@carbonateapp.com">here</a>');
    },
};

export default CustomValidation;


// WEBPACK FOOTER //
// ./scripts/util/custom-validation.js